import React from "react";
import { ArrowForward } from "../Styles/Icons";
import { useHorizontalScrollReset } from "../hooks/useScrollReset";
import SkuMappingColumn from "./SkuMappingColumn";
import { Theme } from "../../Styles";

const ROW_HEIGHT = "64px";

export default function HorizontalTable({
  aiSkuMappings=[],
  pageSize,
  pageNumber,
}) {
  const scrollRef = useHorizontalScrollReset([pageNumber, pageSize]);

  return (
    <div style={baseStyles.root}>
      {/* Table Row */}
      <div style={baseStyles.tableWrapper}>
        {/* Sticky Left Column */}
        <div style={baseStyles.headerColumn}>
          <div style={baseStyles.headerCell}>
            Lab SKU <ArrowForward />
          </div>
          <div style={baseStyles.headerCell}>Lab Product</div>
          <div style={{...baseStyles.headerCell, height: "40px",padding:"0px"}}></div>
          <div
            style={{
              ...baseStyles.headerCell,
              height: "100px",
            }}
          >
            Suggested Dentira Match
          </div>
          <div style={baseStyles.headerCell}>Status</div>
          <div style={baseStyles.headerCell}>Action</div>
        </div>

        {/* Horizontally Scrollable Data Columns */}
        <div ref={scrollRef} style={baseStyles.scrollContainer}>
          <div style={baseStyles.flexTable}>
            {aiSkuMappings.map((aiSkuMapping) => {
              return (
                <SkuMappingColumn
                  key={aiSkuMapping._id}
                  aiSkuMapping={aiSkuMapping}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

const baseStyles = {
  scrollContainer: {
    width: "100%",
    overflowX: "auto",
  },

  flexTable: {
    display: "flex",
    minWidth: "700px",
  },

  headerColumn: {
    display: "flex",
    flexDirection: "column",
    position: "sticky",
    left: 0,
    zIndex: 2,
    background: Theme.creamWhite,
    color: "#5C5C5C",
    borderRadius: "12px 0 0 12px",
    boxShadow: "2px 0 6px rgba(0,0,0,0.05)",
    borderRight: "1px solid #eee",
  },

  dataColumn: {
    display: "flex",
    flexDirection: "column",
    minWidth: "200px",
    fontWeight: 600,
    fontSize: "16px",
  },

  headerCell: {
    fontWeight: 600,
    fontSize: "16px",
    color: "#5f6368",
    padding: "10px 16px",
    minWidth: "180px",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
    height: ROW_HEIGHT,
    background: Theme.creamWhite,
  },

  dataCell: {
    padding: "10px 16px",
    borderBottom: "1px solid #f0f0f0",
    minWidth: "200px",
    display: "flex",
    alignItems: "center",
    color: "#2f2f2f",
    height: ROW_HEIGHT,
    background: "#ffffff",
  },

  tableWrapper: {
    display: "flex",
    width: "100%",
  },

  root: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    height: "100%",
    overflow: "auto",
  },
};
